import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const CommandPaletteContext = createContext({
  open: false,
  setOpen: () => {},
  toggle: () => {},
});

const isEditable = (el) => {
  if (!el) return false;
  const t = el.tagName;
  return (
    el.isContentEditable ||
    t === "INPUT" ||
    t === "TEXTAREA" ||
    t === "SELECT"
  );
};

export function CommandPaletteProvider({ children }) {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((v) => !v), []);

  useEffect(() => {
    const onKey = (e) => {
      // ⌘K / Ctrl+K — always intercept, even inside inputs (like Linear/Notion).
      if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        setOpen((v) => !v);
        return;
      }
      // "/" opens the palette when the user isn't already typing somewhere.
      if (e.key === "/" && !isEditable(document.activeElement) && !open) {
        e.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <CommandPaletteContext.Provider value={{ open, setOpen, toggle }}>
      {children}
    </CommandPaletteContext.Provider>
  );
}

export function useCommandPalette() {
  return useContext(CommandPaletteContext);
}

// ── Recents (last opened records) ────────────────────────────────────────────
const RECENTS_KEY = "fieldops-cmdk-recents";
const RECENTS_MAX = 8;

export function loadRecents() {
  try { return JSON.parse(localStorage.getItem(RECENTS_KEY) || "[]"); } catch { return []; }
}

export function pushRecent(entry) {
  // entry = { id, kind, title, subtitle, to }
  if (!entry || !entry.id || !entry.to) return;
  const list = loadRecents().filter((r) => !(r.id === entry.id && r.kind === entry.kind));
  list.unshift({ ...entry, ts: Date.now() });
  localStorage.setItem(RECENTS_KEY, JSON.stringify(list.slice(0, RECENTS_MAX)));
}
